/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockMenus
 * @description Data access service for managing Stock menus
 */
angular.module('mercury.modules.stock.menu')
.factory('StockMenus', ["$resource", "settings", function($resource, settings) {
  var Menu = $resource(settings.apiHost + '/r/StockMenus/:id', {id: '@id'}, {patch: {method: 'patch'}});
  var MenuItems = $resource(settings.apiHost + '/r/StockMenuItems/:id', {id: '@id'});
  var MenuRecipes = $resource(settings.apiHost + '/r/StockMenuRecipes/:id', {id: '@id'});

  /**
   * Get all menus
   *
   * @memberof StockMenus
   */
  function getAll() {
    return Menu.query();
  }

  /**
   * Get the full details of a specific menu
   *
   * @memberof StockMenus
   * @param {String} id Id of the Menu to get
   */
  function get(id) {
    return Menu.get({id: id});
  }

  /**
   * Get all the stock item and recipes contained in a Menu
   *
   * @memberof StockMenus
   * @param {String} id Id of the menu to get ingredients for
   */
  function getIngredients(id) {
    return MenuItems.query({id: id});
  }

  /**
   * Get all recipe contained in a stock menu
   *
   * @memberof StockMenus
   * @param {String} id Id of the menu to get the recipes for
   */
  function getRecipes(id) {
    return MenuRecipes.query({id: id});
  }

  /**
   * Update a stock menu
   *
   * @memberof StockMenus
   * @param {Object} menu Updated menu model
   */
  function update(menu) {
    return Menu.update(menu).$promise;
  }

  /**
   * Create a new stock menu
   *
   * @memberof StockMenus
   * @param {Object} menu New menu model
   */
  function create(menu) {
    return Menu.save(menu).$promise;
  }

  /**
   * Mark a menu as deleted
   *
   * @memberof StockMenus
   * @param {Object} menu Menu model to delete
   */
  function remove(menu) {
    return Menu.patch({id: menu.id}, [{op: 'replace', path: 'DatestampDeleted', value: moment.utc().format()}]).$promise;
  }

  return {
    getAll: getAll,
    get: get,
    getIngredients: getIngredients,
    getRecipes: getRecipes,
    update: update,
    create: create,
    remove: remove
  };
}]);
